export * from './attachedTrait';
